module.exports = __webpack_public_path__ + "static/media/wave.3cf8a05c.png";